<template>
  <div class="border border-gray-200 rounded-lg p-3 hover:bg-gray-50 transition-colors">
    <div class="flex items-center justify-between gap-2">
      <div class="flex items-center gap-2 min-w-0">
        <span
          class="w-2.5 h-2.5 rounded-full flex-shrink-0"
          :class="dotClass"
        />
        <span class="font-medium text-gray-900 truncate">{{ card.name }}</span>
      </div>
      <div class="flex items-center gap-2 flex-shrink-0">
        <span
          class="text-sm font-semibold"
          :class="textClass"
        >{{ percent }}%</span>
        <button
          type="button"
          class="text-gray-500 hover:text-primary-600 transition-colors"
          :aria-label="ariaLabel"
          @click="openInNewTab"
        >
          <Icon name="mdi-open-in-new" class="w-4 h-4" />
        </button>
      </div>
    </div>
    <p
      v-if="card.reason"
      class="mt-2 text-sm text-gray-600 leading-snug"
    >
      {{ card.reason }}
    </p>
    <p
      v-else
      class="mt-2 text-sm text-gray-400 italic"
    >
      —
    </p>
  </div>
</template>

<script setup lang="ts">
import type { AskAiCard } from '~/composables/useAskAiThread'

const props = defineProps<{
  card: AskAiCard
}>()

const HIGH_THRESHOLD = 70
const MID_THRESHOLD = 50

const percent = computed(() => Math.round(props.card.similarity * 100))

const dotClass = computed(() => {
  if (percent.value >= HIGH_THRESHOLD) return 'bg-green-500'
  if (percent.value >= MID_THRESHOLD) return 'bg-yellow-500'
  return 'bg-red-500'
})

const textClass = computed(() => {
  if (percent.value >= HIGH_THRESHOLD) return 'text-green-600'
  if (percent.value >= MID_THRESHOLD) return 'text-yellow-600'
  return 'text-red-600'
})

const href = computed(() =>
  props.card.kind === 'contact'
    ? `/contacts/${props.card.contactId}/activity`
    : `/businesses/${props.card.businessId}/details/profile`,
)

const ariaLabel = computed(() =>
  props.card.kind === 'contact'
    ? 'Open contact in new tab'
    : 'Open business in new tab',
)

const openInNewTab = () => {
  window.open(href.value, '_blank', 'noopener')
}
</script>
